import { render } from "./ArrowNarrowRight.vue?vue&type=template&id=23fb094c"
import script from "./ArrowNarrowRight.vue?vue&type=script&lang=js"
export * from "./ArrowNarrowRight.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "23fb094c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('23fb094c', script)) {
    api.reload('23fb094c', script)
  }
  
  module.hot.accept("./ArrowNarrowRight.vue?vue&type=template&id=23fb094c", () => {
    api.rerender('23fb094c', render)
  })

}

script.__file = "src/icons/components/filled/ArrowNarrowRight.vue"

export default script